import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DisplayReportJob } from 'app/models/ui';
import { STATUSTYPES } from "../../models/ui/reporting.ui-model";

@Component({
	selector: 'download-status-presentation',
	template: require("./download-status.presentation.html"),
	styles: [require("./download-status.presentation.scss")]
})
export class DownloadStatusPresentation {
	@Output() reportDownloadClicked: EventEmitter<DisplayReportJob> = new EventEmitter();
	@Output() deleteReportJobClicked: EventEmitter<DisplayReportJob> = new EventEmitter();
	@Input() displayReportJobs: DisplayReportJob[];

	statusTypes = STATUSTYPES;
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/download-status/download-status.presentation.ts